import {
  type GridColDef,
  Label,
  LabelColor,
  CancelOutlinedIcon,
  ErrorOutlineIcon,
  CheckCircleOutlineRoundedIcon,
} from '@shared/components';

import { QSetReviewSubtaskReviewResult } from '../../constants';

export interface qSetReviewResultListColumn {
  id: string;
  qid: string;
  reviewResult: QSetReviewSubtaskReviewResult | null;
  comment: number;
  order: number;
  viewDetails: JSX.Element;
}

const QSET_REVIEW_COLOR: Record<QSetReviewSubtaskReviewResult, LabelColor> = {
  [QSetReviewSubtaskReviewResult.Approved]: LabelColor.SUCCESS,
  [QSetReviewSubtaskReviewResult.Rejected]: LabelColor.ERROR,
  [QSetReviewSubtaskReviewResult.ApprovedPartially]: LabelColor.WARNING,
};

const QSET_REVIEW_TEXT: Record<QSetReviewSubtaskReviewResult, string> = {
  [QSetReviewSubtaskReviewResult.Approved]: 'เห็นด้วย',
  [QSetReviewSubtaskReviewResult.Rejected]: 'ไม่เห็นด้วย',
  [QSetReviewSubtaskReviewResult.ApprovedPartially]: 'เห็นด้วยบางส่วน',
};

const QSET_REVIEW_ICON: Record<QSetReviewSubtaskReviewResult, JSX.Element> = {
  [QSetReviewSubtaskReviewResult.Approved]: (
    <CheckCircleOutlineRoundedIcon color='success' sx={{ fontSize: 16 }} />
  ),
  [QSetReviewSubtaskReviewResult.Rejected]: (
    <CancelOutlinedIcon color='error' sx={{ fontSize: 16 }} />
  ),
  [QSetReviewSubtaskReviewResult.ApprovedPartially]: (
    <ErrorOutlineIcon color='warning' sx={{ fontSize: 16 }} />
  ),
};

export const columns: GridColDef<qSetReviewResultListColumn>[] = [
  {
    field: 'order',
    headerName: 'No.',
    width: 100,
    sortable: false,
    renderCell: ({ row }) => {
      return row.order;
    },
  },
  {
    field: 'qid',
    headerName: 'QID',
    sortable: false,
    width: 300,
    renderCell: ({ row }) => {
      return row.qid;
    },
  },
  {
    field: 'reviewResult',
    headerName: 'Review Result',
    sortable: false,
    width: 160,
    renderCell: ({ row }) => {
      return row.reviewResult ? (
        <Label
          color={QSET_REVIEW_COLOR[row.reviewResult]}
          startIcon={QSET_REVIEW_ICON[row.reviewResult]}
          sx={(theme) => ({
            borderRadius: theme.shape.rounded(6),
            width: 'auto',
            ...theme.typography.body2Semibold,
          })}
        >
          {QSET_REVIEW_TEXT[row.reviewResult]}
        </Label>
      ) : (
        '-'
      );
    },
  },
  {
    field: 'comment',
    headerName: '#Comments',
    flex: 1,
    sortable: false,

    renderCell: ({ row }) => {
      return row.comment;
    },
  },
  {
    field: 'questionId',
    headerName: 'View Details',
    sortable: false,
    width: 120,
    renderCell: ({ row }) => {
      return row.viewDetails;
    },
  },
];
